// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3tX2p","options":"AnswerScale_options__19xUi","selected":"AnswerScale_selected__1NtcT"};